//import * as types from '../actions/actionTypes'
// import * as Data from 'content'

const initialState = {
  // navigation: [...Data.Navigation],
  // chapters: [...Data.Chapters],
  // pages: [...Data.Pages],
}

export default (state = initialState, action) => {
  switch(action.type) {
    default:
      return state
  }
}
